<template>
  <div class="main-container">
    <el-carousel :interval="5000" arrow="nerver" height="300px" class="mb-10 bs-10 br-10">
      <el-carousel-item v-for="item in bannerData" :key="item">
        <el-image style="width:100%; height: 300px;" :src="item" :fit="fit"></el-image>
      </el-carousel-item>
    </el-carousel>
    <el-image class="mb-10 bs-10 br-10 db" style="height: 180px;" :src="businessImage" :fit="fit">
    </el-image>
    <div class="about">
      <el-row>
        <el-col :span="24" class="title-main">{{indexData['about'].title}}</el-col>
      </el-row>
      <el-row>
        <el-col :offset="6" :span="12" class="title-sub">{{indexData['about'].subTitle}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-image :src="aboutImage"  class="br-10" style="border: 1px solid #e8e8e8;max-width:570px;height:360px"></el-image>
        </el-col>
        <el-col :span="12">
          <div class="about-content-box h-320">
            <p class="about-text m-b-8" v-html="indexData['about'].content"></p>
          </div>
          <p class="t-a-r">
            <el-button type="info" size="medium" icon="el-icon-menu" @click="moreAboutVisible = true">More</el-button>
          </p>
        </el-col>
      </el-row>
      <el-dialog
      :visible.sync="moreAboutVisible" width="60%" center modal top="0" :lock-scroll=true custom-class="dialog-class">
        <div class="content-inner">
          <p style="font-weight: 700;margin-bottom: 20px;">{{indexData['about'].title}}</p>
          <el-image :src="indexData['about'].coverImage" style="max-width:640px;max-height:360px"></el-image>
          <div class="content-inner-text" v-html="indexData['about'].content"></div>
        </div>
      </el-dialog>
    </div>
    <el-image class="mb-10 bs-10 br-10 db" :src="advantageImage" :fit="fit" ></el-image>
    <div class="service mb-10 bs-10 br-10">
      <div class="service-header">
        <div class="title-main">{{indexData['services'].title}}</div>
        <div class="title-sub">{{indexData['services'].subTitle}}</div>
      </div>
      <div class="service-main">
        <el-row :gutter="10">
          <el-col :span="6" v-for="(item,index) in indexData['services'].imageList" :key="index" style="height: 260px;">
            <div class="image-block">
              <el-image :src="item.url" :fit="fit"  class="br-10" style="height: 190px;"></el-image>
              <span>{{item.title}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="team mb-10 bs-10 br-10">
      <div class="team-header">
        <div class="title-main">{{indexData['team'].title}}</div>
        <div class="title-sub">{{indexData['team'].subTitle}}</div>
      </div>
      <el-carousel :autoplay="false" :interval="5000" arrow="nerver" height="600px">
        <el-carousel-item v-for="(item,index) in indexData['team'].imageList" :key="index">
          <el-image class="br-10 i100" :src="item.url" :fit="fit"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="product mb-10 bs-10 br-10" v-if="JSON.stringify(indexProductData)!=='{}'">
      <div class="product-header">
        <div class="title-main"><!--Out Products-->{{indexData['product'].title}}</div>
        <div class="title-sub"><!--YIREE,A WELL KNOWN INNOVATION DRIVEN STORE FIXTURE COMPANY IN 2018 COMES TO THE
          20TH ANNIVERESARY-->{{indexData['product'].subTitle}}</div>
      </div>
      <el-carousel :autoplay="false" :interval="5000" arrow="nerver" height="499px">
        <el-carousel-item v-for="(item,index) in indexProductData" :key="index">
          <div class="product-list">
            <div class="product-box-1 br-10">
              <!--template v-if="item.imageList.length > 0">
                <el-image :src="item.imageList[0].url" :fit="fit" class="ib i100 br-10"></el-image>
              </template-->
              <template v-if="item.length > 0">
                <el-image :src="item[0].url" :fit="fit" class="ib i100 br-10"></el-image>
              </template>
            </div>
            <div class="product-box-2">
              <div class="product-box-2-1"></div>
              <div class="product-box-2-2 br-10">
                <!--template v-if="item.imageList.length > 1">
                  <el-image :src="item.imageList[1].url" :fit="fit" class="ib i100 br-10"></el-image>
                </template-->
                <template v-if="item.length > 1">
                  <el-image :src="item[1].url" :fit="fit" class="ib i100 br-10"></el-image>
                </template>
              </div>
              <div class="product-box-2-2 br-10">
                <!--template v-if="item.imageList.length > 2">
                  <el-image :src="item.imageList[2].url" :fit="fit" class="ib i100 br-10"></el-image>
                </template-->
                <template v-if="item.length > 2">
                  <el-image :src="item[2].url" :fit="fit" class="ib i100 br-10"></el-image>
                </template>
              </div>
            </div>
            <div class="product-box-3">
              <div class="product-box-3-1">
                <p class="title-number">{{index<9?'0'+(index+1):index+1}}</p>
                <p class="title-main">STRICTLY SELECTED</p>
                <p class="title-sub">严选臻品</p>
                <div class="more-box" @click="moreProduct">
                  <i class="el-icon-menu"></i>
                  <div>更多</div>
                </div>
              </div>
              <div class="product-box-3-2">
                <!--template v-if="item.imageList.length > 3">
                  <el-image :src="item.imageList[3].url" :fit="fit" class="ib i100 br-10"></el-image>
                </template-->
                <template v-if="item.length > 3">
                  <el-image :src="item[3].url" :fit="fit" class="ib i100 br-10"></el-image>
                </template>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="case mb-10 bs-10 br-10">
      <div class="case-header">
        <div class="title-main">{{indexData['case'].title}}</div>
        <div class="title-sub">{{indexData['case'].subTitle}}</div>
      </div>
      <div class="case-main">
        <el-row :gutter="10" style="margin-bottom: 0px;">
          <el-col :span="8" v-for="(item,index) in indexData['case'].imageList" :key="index">
            <div class="image-block" style="margin-bottom: 10px;">
              <el-image :src="item.url" :fit="fit" class="i100 br-10 ib"></el-image>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="honor mb-10 bs-10 br-10">
      <div class="honor-header">
        <div class="title-main"><!--CERTIFICATE SHOW-->{{indexData['honor'].title}}</div>
        <div class="title-sub">{{indexData['honor'].subTitle}}</div>
      </div>
      <!--el-carousel :autoplay="false" :interval="5000" arrow="never">
        <el-carousel-item v-for="(item,index) in indexHonorData" :key="index">
          <el-row :gutter="20" style="padding-left: 10px; height: 250px; overflow: hidden;">
            <el-col :span="4" v-for="(image,index2) in item.imageList" :key="index2" style="width: 240px;height:250px">
              <el-image :src="image.url" :fit="fit" class="i100 br-10 ib"></el-image>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel-->
      <el-carousel :autoplay="false" :interval="5000" arrow="never">
        <template v-for="(item,index) in honorData">
          <el-carousel-item v-if="index % 5 == 0 && honorData.length>=(index+5)">
            <el-row :gutter="20" style="padding-left: 10px; height: 250px; overflow: hidden;">
              <el-col :span="4" style="width: 240px;height:250px;">
                <el-image :src="honorData[index].url" :fit="fit" class="i100 br-10"></el-image>
              </el-col>
              <el-col :span="4" style="width: 240px;height:250px;">
                <el-image :src="honorData[index+1].url" :fit="fit" class="i100 br-10"></el-image>
              </el-col>
              <el-col :span="4" style="width: 240px;height:250px;">
                <el-image :src="honorData[index+2].url" :fit="fit" class="i100 br-10"></el-image>
              </el-col>
              <el-col :span="4" style="width: 240px;height:250px;">
                <el-image :src="honorData[index+3].url" :fit="fit" class="i100 br-10"></el-image>
              </el-col>
              <el-col :span="4" style="width: 240px;height:250px;">
                <el-image :src="honorData[index+4].url" :fit="fit" class="i100 br-10"></el-image>
              </el-col>
            </el-row>
          </el-carousel-item>
        </template>
      </el-carousel>
    </div>
    <div class="cooperative mb-10 bs-10 br-10">
      <div class="c_header">
        <div class="title-main"><!--Cooperative-->{{indexData['partner'].title}}</div>
        <div class="title-sub"><!--YIREE,A WELL KNOWN INNOVATION DRIVEN STORE FIXTURE COMPANY IN 2018 COMES TO THE
          20TH ANNIVERESARY-->{{indexData['partner'].subTitle}}</div>
      </div>
      <el-carousel height="250px" :autoplay="false" :interval="5000" arrow="hover">
        <el-carousel-item v-for="(item,index) in indexPartnerData" :key="index">
          <el-row :gutter="15" style="margin-right: -6px;">
            <el-col :span="4" v-for="(itemx,index2) in item" :key="index2">
              <el-image :src="itemx.url" :fit="fit" class="i100" style="margin-bottom: 10px;"></el-image>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  //import Bus from "../api/Bus";
  export default {
    name: 'Main',
    data() {
      return {
        fit: 'fit',
        /*aboutus: require('@/assets/about-us.png'),*/
        indexData: {
          index: {},
          about: {},
          business: {},
          advantage: {},
          services: {},
          team: {},
          product: {},
          case: {},
          honor: {},
          partner: {}
        },
        bannerData: {},
        aboutData: {},
        indexProductData: {},
        indexHonorData: {},
        honorData: {},
        indexPartnerData: {},
        businessImage: '',
        aboutImage: '',
        advantageImage: '',
        moreAboutVisible: false
      }
    },
    methods: {
      getBanner() {
        this.$axios.get('/api/banner').then(res => {
            if (res.data.code == '0') {
              this.bannerData = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      getData() {
        this.$axios.get('/api/index/all').then(res => {
            if (res.data.code == '0') {
              let resData = this.indexData['index'] = res.data.data;
              console.log('index = ',resData);
              for (let i = 0; i < resData.length; i++) {
                this.indexData[resData[i].moduleKey] = resData[i];
              }
              this.businessImage = this.indexData['business'].coverImage;
              this.aboutImage = this.indexData['about'].coverImage;
              this.advantageImage = this.indexData['advantage'].coverImage;
              this.honorData = this.indexData['honor'].imageList;
              //console.log(this.indexData);
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      /*getProductData1() {
        this.$axios.get('/api/indexproduct').then(res => {
            if (res.data.code == '0') {
              this.indexProductData = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },*/
      getProductData() {
        this.$axios.get('/api/index/product').then(res => {
            if (res.data.code == '0' && res.data.data.length>0) {
              this.indexProductData = res.data.data[0].imageGroup;
            } /*else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }*/
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
          console.log("indexProductData = ",JSON.stringify(this.indexProductData)==='{}');
      },
      getHonorData() {
        this.$axios.get('/api/indexhonor').then(res => {
            if (res.data.code == '0') {
              this.indexHonorData = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      getPartnerData() {
        this.$axios.get('/api/index/partner').then(res => {
            if (res.data.code == '0') {
              this.indexPartnerData = res.data.data[0].imageGroup;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      moreProduct() {
        this.$router.push('/product');
        //Bus.$emit("menu","/product");
      }
    },
    mounted: function() {
      this.getBanner();
      this.getData();
      this.getProductData();
      this.getHonorData();
      this.getPartnerData();
    },
  }
</script>

<style scoped>
  .main-container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
  }
  .about {
    height: 500px;
    padding-top: 30px;
    margin-bottom: 10px;
    box-shadow: 10px 10px 5px #888888;
    border-radius: 10px;
    background: #FFF;
  }

  .t-a-r {
    text-align: right;
    padding-right: 20px;
  }
  .service {
    background: #FFF;
    padding: 10px 10px 0 10px;
  }

  .cooperative{
    background: #FFF;
    padding: 30px 10px 0 10px;

  }
  .about-header,
  .service-header,
  .team-header,
  .product-header,
  .case-header,
  .honor-header,
  .cooperative .header {
    width: 50%;
    margin: 0 auto;
    /*margin-bottom: 30px;*/
    margin-bottom: 10px;
  }


  .title-main {
    font-size: 28px;
    padding-bottom: 20px;
    font-size: 35px;
    font-weight: bold;
  }

  .title-sub {
    font-size: 16px;
    padding-bottom: 30px;
  }

  .about-main {
    /*height: 400px;*/
  }

  .image-block {
    height: 245px;
  }

  .image-block span {
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .team {
    text-align: center;
    /* margin: 0 auto; */
    background: #FFFFFF;
    padding: 20px 10px 10px 10px;
  }

  .product {
    background: #FFF;
    padding: 20px 10px 10px 10px;
  }

  .case {
    background: #FFF;
    padding: 20px 10px 10px 10px;
  }

  .product-list {
    max-width: 1120px;
    height: 496px;
    margin: 0 auto;
    display: flex;
  }

  .product-box-1 {
    width: 500px;
    height: 496px;
    /* overflow: hidden; */
  }

  .product-box-2,
  .product-box-3 {
    width: 300px;
    margin-left: 10px;
    height: 496px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* overflow: hidden; */
  }

  .product-box-2-1 {
    width: 302px;
    height: 60px;
  }

  .product-box-2-2 {
    width: 302px;
    height: 200px;
    /* overflow: hidden; */
  }

  .product-box-3-1 {
    width: 302px;
    height: 260px;
    text-align: right;
    float: right;
  }

  .product-box-3-1 p {
    color: #333;
  }

  .product-box-3-1 .title-number {
    font-size: 70px;
    font-family: PUHuiLight;
    font-weight: lighter;
    color: #999;
  }

  .product-box-3-1 .title-main {
    font-size: 26px;
    line-height: 26px;
    margin: 0 0 5px;
    padding: 0;
    font-family: PUHuiLight;
    font-weight: lighter;
    color: #999;
  }

  .product-box-3-1 .title-sub {
    font-size: 26px;
    line-height: 26px;
    margin: 0 0 5px;
    font-family: PUHuiLight;
    font-weight: lighter;
    color: #999;
  }

  .product-box-3-2 {
    width: 302px;
    height: 200px;
    overflow: hidden;
  }

  .more-box {
    font-size: 24px;
    color: #000;
    width: 24px;
    float: right;
    text-align: right;
    cursor: pointer;
  }

  .more-box div {
    font-size: 10px;
    color: #000;
  }

  .honor {
    width: 100%;
    /*height: 400px;*/
    /*background: #99A9BF;*/
    background:#FFF;
  }

  .honor .title-main {
    font-size: 35px;
    font-weight: bold;
    color: #000;
    padding-top: 30px;
    padding-bottom: 20px;
  }

  .honor .el-col {
    height: 200px;
  }

  .honor .el-row {
    padding-left: 7.5px;
    padding-right: 7.5px;
    /*padding-left: calc((100% - ((100% / 24) * 4 * 5)) / 2);
    padding-right: calc((100% - ((100% / 24) * 4 * 5)) / 2);*/
  }

  .cooperative .el-image {
    /* width: 120px; */
    height: 100px;
    border-radius: 10px;
    border: 1px solid #E8E8E8;
  }

  .about-content-box{
    /*border: 1px solid red;*/
  }

  .about-text {
    font-size: 15px;
    text-align: justify;
    line-height: 24px;
    padding: 0 20px;
    overflow: hidden;
    height: 315px;
    /*display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;*/
    margin-bottom: 5px;
    word-wrap: break-word;
    word-break: normal;
  }

/*  .cooperative .el-row .el-col .el-image {
    width: 100%;
  } */

  .content-inner {
    padding: 0 15px;
    text-align: center;
    height: 100%;
  }
  .content-inner-text {
    margin-top: 20px;
    text-align: left;
    word-wrap:break-word;
    word-break:normal;
  }

  .ib {
    border:1px solid #E8E8E8;
    padding: 0;
  }

  .i100{
    width: 100%;
    height: 100%;
  }

</style>
<style>
  .el-dialog__wrapper {
    overflow-y: hidden;
  }
  .dialog-class {
    height: 100%;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue